import { FIRST_LOAD_STATE_WAIT_MS } from 'projects/service/src/app/shared/utils/grid-persistence';
import { ActionIconDef, GridConfig } from '@inavista/components/grid';
import { REMOTE_SEARCH_ROW_KEY } from '../../utils/remote-search-grid-api';

// Technicians popup (Inventory adjustment and Inventory transfer request popups) on @inavista/components. Same
// columns, labels, order, alignment, toolbar (Search, Clear filters) and Proceed arrow as the Syncfusion grid it
// replaces. Rows come from the same endpoint with the same request (POST ServiceEmployee/GetEmployeeSearchView,
// RemoteSearchGridApi); 50 rows per request, loaded as the user scrolls. No paging (Martin).

export const RESOURCE_SELECTION_PERSISTENCE_KEY = 'rims.service.resource-selection-technicians';
export const RESOURCE_SELECTION_URL = 'rims-search://resource-selection';
export const PROCEED_ACTION = 'proceed';

const ARROW_RIGHT_ICON = '<line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />';

/** The old command column: one "Proceed" arrow (fas fa-arrow-right), 120px. */
export const PROCEED_ACTION_ICONS: ActionIconDef[] = [
  { key: PROCEED_ACTION, label: 'Proceed', icon: ARROW_RIGHT_ICON, colorFn: () => '#000000de' },
];

// EmployeeSearchView fields. ID was hidden and out of the column chooser.
export const RESOURCE_SELECTION_COLUMNS: [string, string][] = [
  ['id', 'nvarchar'],
  ['company', 'nvarchar'],
  ['employeeId', 'nvarchar'],
  ['employeeName', 'nvarchar'],
  ['serviceDepartment', 'nvarchar'],
];

export function buildResourceSelectionGridConfig(): GridConfig {
  const order = RESOURCE_SELECTION_COLUMNS.map(([c]) => c);
  const shown = order.filter(c => c !== 'id');
  return {
    apiBaseUrl: RESOURCE_SELECTION_URL,
    keyColumn: REMOTE_SEARCH_ROW_KEY,
    // The old page size.
    pageSize: 50,
    rowHeight: 30,
    defaultColumnOrder: order,
    // Company is not shown (Martin, 2026-10-29: one company per tenant); it stays in the picked row.
    hiddenByDefaultColumns: ['company', 'id', REMOTE_SEARCH_ROW_KEY],
    columnLabels: {
      id: 'ID', company: 'Company', employeeId: 'Technician ID', employeeName: 'Technician Name',
      serviceDepartment: 'Service Department',
    },
    // Every column left, as the old grid (no textAlign).
    columnAlign: Object.fromEntries(shown.map(c => [c, { horizontal: 'left' as const, header: { horizontal: 'left' as const } }])),
    // No widths in the old grid: the columns shared the popup's width.
    columnWidths: Object.fromEntries(shown.map(c => [c, 150])),
    stretchColumns: true,
    // The old Actions column was 120px wide.
    actionsColumnMinWidth: 120,
    searchHint: 'Searches every column.',
    // The old toolbar: Search and Clear all Filters only.
    enableColumnsPicker: false,
    enableExport: false,
    enableSavedViews: false,
    enableScrollButtons: false,
    enableFitColumns: false,
    enableRefresh: false,
    // Ctrl+click adds a sort column, as the old grid (Syncfusion multi-sort).
    multiSort: true,
    enableResetLayout: true,
    // The footer gives the old "Total Records" count.
    enableFooter: true,
    loadingIndicator: 'banner',
    emptyStateMessage: 'No records to display',
    // Right-click a cell filters by its value (Martin, 2026-10-29: every grid that filters).
    enableContextMenuFilter: true,
    persistenceKey: RESOURCE_SELECTION_PERSISTENCE_KEY,
    firstLoadStateWaitMs: FIRST_LOAD_STATE_WAIT_MS,
  };
}
